import { MotiView } from "moti";
import type { ColorTokens } from "tamagui";
import type { IconProps } from "@tamagui/helpers-icon";
import { LoaderCircle as LoaderCircleIcon } from "@tamagui/lucide-icons";
import { durations, easings } from "../config/animations";
import { ICON_STROKE_WIDTH } from "./Icon";
type LoaderSize = IconProps["size"];
export type LoaderProps = {
  size?: LoaderSize;
  color?: ColorTokens;
  duration?: number;
};

/**
 * A cross-platform loading spinner using the Lucide LoaderCircle icon
 * with a continuous rotation animation via Moti.
 */
export const Loader = ({
  size = "$iconMedium",
  color = "$textDisabled"
}: LoaderProps) => {
  return <MotiView from={{
    rotate: "0deg"
  }} animate={{
    rotate: "360deg"
  }} transition={{
    loop: true,
    repeatReverse: false,
    type: "timing",
    easing: easings.easeInOut,
    duration: durations.long
  }} data-sentry-element="MotiView" data-sentry-component="Loader" data-sentry-source-file="Loader.tsx">
      <LoaderCircleIcon size={size} color={color} strokeWidth={ICON_STROKE_WIDTH} data-sentry-element="LoaderCircleIcon" data-sentry-source-file="Loader.tsx" />
    </MotiView>;
};